import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import { ResponsiveSelect } from "../../../../../components/MobileForm";
import { SegmentedControl } from "../../../../../components/SegmentedControl";
import {
  SORT_OPTIONS,
  sortStateToValue,
  valueToSortState,
} from "./sortOptions";
import {
  SearchClearButton,
  SearchField,
  SearchIcon,
  SearchInput,
  Toolbar,
  ToolbarGroup,
} from "./styles";
import {
  HoldingAssetFilter,
  HoldingsToolbarProps,
  HoldingStatusFilter,
} from "./types";

const HoldingsToolbarComponent: React.FC<HoldingsToolbarProps> = ({
  query,
  onQueryChange,
  status,
  onStatusChange,
  assetGroup,
  onAssetGroupChange,
  assetOptions,
  isCompact,
  sort,
  onSortChange,
}) => {
  const statusOptions = [
    { value: "open" as HoldingStatusFilter, label: "Open" },
    { value: "closed" as HoldingStatusFilter, label: "Closed" },
  ];

  return (
    <Toolbar>
      <SearchField>
        <SearchIcon>
          <SearchRoundedIcon />
        </SearchIcon>
        <SearchInput
          type="search"
          value={query}
          aria-label="Search holdings"
          placeholder="Search holdings"
          onChange={(event) => onQueryChange(event.target.value)}
        />
        {query !== "" && (
          <SearchClearButton
            size="small"
            aria-label="Clear search"
            onClick={() => onQueryChange("")}
          >
            <CloseRoundedIcon />
          </SearchClearButton>
        )}
      </SearchField>

      <ToolbarGroup>
        <SegmentedControl
          options={statusOptions}
          value={status}
          onChange={onStatusChange}
          ariaLabel="Position status"
          testId="holdings-status-filter"
        />

        <ResponsiveSelect
          isCompact={isCompact}
          options={assetOptions}
          value={assetGroup}
          onChange={(option) =>
            onAssetGroupChange(option.value as HoldingAssetFilter)
          }
          sheetTitle="Filter by asset type"
          testId="holdings-asset-filter"
        />

        {/* The card list has no column headers to click, so the sort keys are offered as a select instead. */}
        {isCompact && (
          <ResponsiveSelect
            isCompact={isCompact}
            options={SORT_OPTIONS}
            value={sortStateToValue(sort)}
            onChange={(option) => onSortChange(valueToSortState(option.value))}
            sheetTitle="Sort holdings"
            testId="holdings-sort"
          />
        )}
      </ToolbarGroup>
    </Toolbar>
  );
};

export const HoldingsToolbar = React.memo(HoldingsToolbarComponent);
